<template>
    <div class="inventory-info">
        <div class="main-content-full">
            <div class="controller-container">
                <div class="controller-content">
                    <el-select class="action-select-first" @change="selectInventoryClass" v-model="inventoryClassIndex" placeholder="选择直发库">
                        <el-option
                          v-for="(item, index) in inventoryClassArr"
                          :key="index" :label="item.warehouse_name" 
                          :value="item.warehouse_id">
                        </el-option>
                    </el-select>
                    <el-cascader v-if="userTypeNum == 0" class="action-select-inventory" placeholder="选择经销商仓库" :filterable="true" :clearable="true" :options="oneLevelInventoryArr" v-model="oneLevelInventory" @change="selectOneLevelInventory">
                    </el-cascader>
                    <el-cascader v-if="userTypeNum == 1 || userTypeNum == 0" class="action-select-inventory" placeholder="选择门店/加油站仓库" :filterable="true" :clearable="true" :options="twoLevelInventoryArr" v-model="twoLevelInventory" @change="selectTwoLevelInventory">
                    </el-cascader>
                </div>
            </div>
            <div class="table-container">
                <el-table :data="tableData" style="width: 100%" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                    <el-table-column align="center" prop="classification" label="分类" min-width="13%">
                    </el-table-column>
                    <el-table-column align="center" label="商品名称" min-width="30%">
                        <template slot-scope="scope">
                            <div class="table-product-name">{{scope.row.name}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="current_nums" label="商品库存" min-width="13%">
                    </el-table-column>
                    <el-table-column align="center" prop="unit" label="规格" min-width="13%">
                    </el-table-column>
                    <el-table-column align="center" prop="belong" label="仓库" min-width="13%">
                    </el-table-column>
                    <el-table-column align="center" prop="status" label="商品库存状态" min-width="13%">
                    </el-table-column>
                </el-table>
                <!-- 分页S -->
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  background
                  layout="prev, pager, next"
                  :total="totalCount"
                  >
                </el-pagination>
                <!-- 分页E -->
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
export default {
    data () {
        return {
            inventoryClassArr: [],
            inventoryClassIndex: '',
            tableData: [],
            currentWarehouse_id: '',
            oneLevelInventoryArr: [],
            twoLevelInventoryArr: [],
            oneLevelInventory: [],
            twoLevelInventory: [],
            // 分页
            currentPage:1, //初始页
            pagesize:10,  //每页的数据
            totalCount: 0 // 总条数
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created () {
        this.init();
        
    },
    methods: {
        changeTableHeaderStyle({row, rowIndex}) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle ({row, column, rowIndex, columnIndex}) {
            if(columnIndex == 5) {
                if(row.status_num == -1) {
                    return 'color: #FF3333;'
                }
                else if(row.status_num == 0) {
                    return 'color: #29bd7f;'
                }
                else if(row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
        init() {
            /**
             * @type: 为1为自己同级，为2查看上级
             */
            this.axios.get('getwarehouse', {
                params: {
                    user_id: this.user.id, 
                    type: 1
                }
            })
            .then(async res => {
                 this.inventoryClassArr = res.data.data;
                if(this.$route.query.warehouse_id == undefined) {
                    this.currentWarehouse_id = res.data.data[0].warehouse_id;
                }
                else {
                    this.currentWarehouse_id = this.$route.query.warehouse_id;
                }
                this.getInventoryTableData(this.currentWarehouse_id, 0);
                if(this.userTypeNum == 0) {
                    this.getInventoryStructure(this.user.id, 1, 'oneLevel');
                    this.getInventoryStructure(this.user.id, 2, 'twoLevel');
                }
                else if(this.userTypeNum == 1) {
                    this.getInventoryStructure(this.user.id, 1, 'twoLevel');
                }
            })
        },
        getInventoryStructure(user_id, branch_type, level) {
            this.axios.get('getbranchwarehouse', {
                params: {
                    user_id: user_id,
                    branch_type: branch_type
                }
            })
            .then(res => {
                if(level == 'twoLevel') {
                    this.twoLevelInventoryArr = res.data.data;
                }
                else {
                    this.oneLevelInventoryArr = res.data.data;
                }
            })
        },
        getInventoryTableData(warehouse_id, class_id,page=1) {
            this.axios.get('obtain_warehouse_info', {
                params: {
                    warehouse_id: warehouse_id,
                    class_id: class_id,
                    // 分页
                    page_num: page, // 出现几页
                    page_size: 10 // 每页有多少条数据
                }
            })
            .then(res => {
                console.log('222', res)
                this.tableData = res.data.data // 表格数据渲染
                this.totalCount = res.data.obj_count // 显示总数据条数
                console.log('999', this.tableData)
            })
        },
        // 选择直发库
        selectInventoryClass(warehouseId, classId) {
            this.getInventoryTableData(warehouseId, 0)
        },
        // 选择下级仓库结构
        selectOneLevelInventory() {
            this.currentWarehouse_id = this.oneLevelInventory[1];
            this.getInventoryTableData(this.currentWarehouse_id, 0)
        },
        // 选择下2级仓库结构
        selectTwoLevelInventory() {
            this.currentWarehouse_id = this.twoLevelInventory[2];
            this.getInventoryTableData(this.currentWarehouse_id, 0)
        },
        // 分页事件
        handleCurrentChange(page) {
          this.currentPage = page
          console.log('page',page)
          this.getInventoryTableData(this.currentWarehouse_id, 0, page)
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.inventory-info .controller-container {
    background-color: #d2f5e8;
}
.inventory-info .controller-content {
    width: 90%;
    margin: 0 auto;
}
.action-select-first,
.action-select-inventory {
    margin-left: 24px;
    width: 161px;
}
.action-select-first {
    margin-left: 0px;
}
.table-product-name {
    text-align: left;
    padding-left: 34px;
    color: #46a0fe;
}
</style>




// WEBPACK FOOTER //
// src/pages/inventoryManage/InventoryInfo.vue